<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17srtx7/tc-custom/9781488065651.jpg?1707506208902" alt="This image is the cover for the book Their Marriage of Inconvenience"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Their Marriage of Inconvenience
      </h1>
      <p class="bookDescription body article font2">
        <p>Opposites in everything…  Except needing to marry!  For Adelia Worthington, only marrying railway magnate Simeon Morgan will secure her family’s home. In return, she’ll give Simeon a place in society. A marriage is the last thing either wants, especially when it’s clear this self-made man thinks she’s a pampered heiress! But what’s even more inconvenient than their marriage is that the sparks of fury that fly between them are igniting a simmering desire that won’t be ignored.  “Romantic, full of secrets and simmering passion this Regency romance is the perfect escape.” — Jane Hunter on The Cinderella Countess  “A definite buy book. I adore this author.” — Goodreads on The Cinderella Countess</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sophia James
      </h2>
      
      <p class="authorDescription body article">Georgette Heyer novels formed Sophia James&rsquo;s reading tastes as a teenager. But her writing life only started when she was given a pile of Mills &amp; Boons to read after she had had her wisdom teeth extracted! Filled with strong painkillers she imagined that she could pen one, too. Many drafts later Sophia thinks she has the perfect job writing for Harlequin Historical as well as taking art tours to Europe with her husband, who is a painter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ab74952